import { render, staticRenderFns } from "./matter_package_rule.vue?vue&type=template&id=a4155896&scoped=true&"
import script from "./matter_package_rule.vue?vue&type=script&lang=js&"
export * from "./matter_package_rule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4155896",
  null
  
)

export default component.exports